import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'loaders.css';
import '../css/Main.css';

class Main extends Component {
  constructor() {
    super();
    this.state = {
      preload: true
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        preload: false
      })
    }, 2500)
  }

  render() {
    return (
      <div className="Main">
        <div className="Main__Body container-fluid">
          { this.state.preload
          ? <div className="Main__Preloader"> 
            <div class="load">
              <div class="gear one">
                <svg id="blue" viewbox="0 0 100 100" fill="#94DDFF">
                  <path d="M97.6,55.7V44.3l-13.6-2.9c-0.8-3.3-2.1-6.4-3.9-9.3l7.6-11.7l-8-8L67.9,20c-2.9-1.7-6-3.1-9.3-3.9L55.7,2.4H44.3l-2.9,13.6      c-3.3,0.8-6.4,2.1-9.3,3.9l-11.7-7.6l-8,8L20,32.1c-1.7,2.9-3.1,6-3.9,9.3L2.4,44.3v11.4l13.6,2.9c0.8,3.3,2.1,6.4,3.9,9.3      l-7.6,11.7l8,8L32.1,80c2.9,1.7,6,3.1,9.3,3.9l2.9,13.6h11.4l2.9-13.6c3.3-0.8,6.4-2.1,9.3-3.9l11.7,7.6l8-8L80,67.9      c1.7-2.9,3.1-6,3.9-9.3L97.6,55.7z M50,65.6c-8.7,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6S58.7,65.6,50,65.6z"></path>
                </svg>
              </div>
              <div class="gear two">
                <svg id="pink" viewbox="0 0 100 100" fill="#FB8BB9">
                  <path d="M97.6,55.7V44.3l-13.6-2.9c-0.8-3.3-2.1-6.4-3.9-9.3l7.6-11.7l-8-8L67.9,20c-2.9-1.7-6-3.1-9.3-3.9L55.7,2.4H44.3l-2.9,13.6      c-3.3,0.8-6.4,2.1-9.3,3.9l-11.7-7.6l-8,8L20,32.1c-1.7,2.9-3.1,6-3.9,9.3L2.4,44.3v11.4l13.6,2.9c0.8,3.3,2.1,6.4,3.9,9.3      l-7.6,11.7l8,8L32.1,80c2.9,1.7,6,3.1,9.3,3.9l2.9,13.6h11.4l2.9-13.6c3.3-0.8,6.4-2.1,9.3-3.9l11.7,7.6l8-8L80,67.9      c1.7-2.9,3.1-6,3.9-9.3L97.6,55.7z M50,65.6c-8.7,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6S58.7,65.6,50,65.6z"></path>
                </svg>
              </div>
              <div class="gear three">
                <svg id="yellow" viewbox="0 0 100 100" fill="#FFCD5C">
                  <path d="M97.6,55.7V44.3l-13.6-2.9c-0.8-3.3-2.1-6.4-3.9-9.3l7.6-11.7l-8-8L67.9,20c-2.9-1.7-6-3.1-9.3-3.9L55.7,2.4H44.3l-2.9,13.6      c-3.3,0.8-6.4,2.1-9.3,3.9l-11.7-7.6l-8,8L20,32.1c-1.7,2.9-3.1,6-3.9,9.3L2.4,44.3v11.4l13.6,2.9c0.8,3.3,2.1,6.4,3.9,9.3      l-7.6,11.7l8,8L32.1,80c2.9,1.7,6,3.1,9.3,3.9l2.9,13.6h11.4l2.9-13.6c3.3-0.8,6.4-2.1,9.3-3.9l11.7,7.6l8-8L80,67.9      c1.7-2.9,3.1-6,3.9-9.3L97.6,55.7z M50,65.6c-8.7,0-15.6-7-15.6-15.6s7-15.6,15.6-15.6s15.6,7,15.6,15.6S58.7,65.6,50,65.6z"></path>
                </svg>
              </div>
              <div class="lil-circle"></div>
              <svg class="blur-circle">
                <filter id="blur">
                  <fegaussianblur in="SourceGraphic" stddeviation="13"></fegaussianblur>
                </filter>
                <circle cx="70" cy="70" r="66" fill="transparent" stroke="white" stroke-width="40" filter="url(#blur)"></circle>
              </svg>
            </div>
          </div>
          : <div/>
          }
          <div className="Main__BodyContent col-xl-12">
            <div className="col-xl-12">
              {/* Header */}
              <div className="row">
                <div className="col-xl-1"/>
                <div className="Main__BodyContent__Text col-xl-6">
                  <h1>Hey, I'm Eddie</h1>
                  <p>
                    Hi! I'm Eddie Ron Adolph A. Vallejos. Web Developer by night, still a Web Developer by day. 
                    I have a passion for making web applications. I started to love web development when I was
                    still an undergraduate student of the <a href="https://uplb.edu.ph/">University of the Philippines Los Baños</a>.
                  </p>
                  <p>
                    I take work even more seriously. Yes, I'd say that I'm a fun and friendly. I can also adapt quickly to
                    a new environment and I enjoy playing and working with a team. I also love learning new things every day.
                    I manage and finish my tasks quickly or sometimes on time without compromising the quality of the product.
                  </p>
                  <p><strong>TL;DR</strong> Please hire me</p>
                </div>
                <div className="Main__BodyContent__Text col-xl-4">
                  <br/><br/>
                  <h2>SECTION UNDER CONSTRUCTION!</h2>
                  <br/>
                  <h2>Temporary Portfolio</h2>
                  <h2>GitHub Account:</h2>
                  <a href="https://github.com/EddieVallejos">https://github.com/EddieVallejos</a>
                </div>
              </div>
              {/* Body */}
              <div className="row">
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js